import { computed, Injectable, signal } from '@angular/core';

import { TERMINAL_V2_NOTIFICATION_RESET_DURATION_MS, TERMINAL_V2_TEXT_INFO_TYPE } from '@app/models/api/terminal-v2/terminal-v2.model';
import Nullable from '@app/models/typescript/nullable.model';

@Injectable({
  providedIn: 'root',
})
export class TerminalV2NotificationMessageService {
  private resetTimerId: ReturnType<typeof setTimeout> | null = null;

  private defaultInfoText = signal<Nullable<string>>(null);
  private defaultInfoIcon = signal<Nullable<string>>(null);
  private notificationText = signal<Nullable<string>>(null);
  private notificationType = signal<Nullable<TERMINAL_V2_TEXT_INFO_TYPE>>(null);
  private monthlyBalance = signal<Nullable<number>>(null);

  public readonly displayedMonthlyBalance = computed(() => this.monthlyBalance());
  public readonly displayedType = computed(() => this.notificationType());
  public readonly displayedText = computed(() => this.notificationText() ?? this.defaultInfoText());
  public readonly displayedIcon = computed(() => {
    if (this.notificationType()) {
      return this.notificationType() === TERMINAL_V2_TEXT_INFO_TYPE.ERROR ? 'circle-xmark' : 'circle-check';
    }
    return this.defaultInfoIcon();
  });

  public setTerminalV2DefaultInfo(text: string, icon: Nullable<string> = null): void {
    this.defaultInfoText.set(text);
    this.defaultInfoIcon.set(icon);
  }

  public setNewNotification(newNotificationText: string, type: TERMINAL_V2_TEXT_INFO_TYPE, monthlyBalance: Nullable<number> = null): void {
    if (this.resetTimerId) {
      clearTimeout(this.resetTimerId);
      this.resetTimerId = null;
    }

    this.notificationText.set(newNotificationText);
    this.notificationType.set(type);
    this.monthlyBalance.set(monthlyBalance);

    if ([TERMINAL_V2_TEXT_INFO_TYPE.ERROR, TERMINAL_V2_TEXT_INFO_TYPE.SUCCESS].includes(type)) {
      this.resetTimerId = setTimeout(() => {
        this.resetNotification();
      }, TERMINAL_V2_NOTIFICATION_RESET_DURATION_MS);
    }
  }

  private resetNotification(): void {
    this.notificationText.set(null);
    this.notificationType.set(null);
    this.monthlyBalance.set(null);
    this.resetTimerId = null;
  }
}
